<template>
    <div class="checkout">
        <Header :title="$t('checkout_step', {checkoutStep})" :info="info" @close-checkout="closeCheckout"/>
        <main>
            <div class="container checkout-container">
                <step1 v-if="checkoutStep === 1" @info="setInfo"/>
                <step2 v-if="checkoutStep === 2" @info="setInfo"/>
                <step3 v-if="checkoutStep === 3" @info="setInfo"/>
                <step4 v-if="checkoutStep === 4" @info="setInfo"/>
                <step5 v-if="checkoutStep === 5" @info="setInfo"/>
                <step6 v-if="checkoutStep === 6" @info="setInfo"/>
            </div>
        </main>
        <Footer :step="checkoutStep" @close-checkout="closeCheckout"/>
    </div>
</template>

<style lang="scss" scoped>
    main {
        padding: 100px 0;
    }

    body.-is-mobile {

        main {
            padding: 100px 0 80px;
        }
    }
</style>

<script>
  import Header from './checkout/partials/Header.vue';
  import Footer from './checkout/partials/Footer.vue';

  import Step1 from './checkout/Step1.vue';
  import Step2 from './checkout/Step2.vue';
  import Step3 from './checkout/Step3.vue';
  import Step4 from './checkout/Step4.vue';
  import Step5 from './checkout/Step5.vue';
  import Step6 from './checkout/Step6.vue';

  import checkout from 'src/mixins/checkoutComponent';

  export default {
    mixins: [checkout],
    components: {
      Header,
      Footer,
      Step1,
      Step2,
      Step3,
      Step4,
      Step5,
      Step6,
    },
  };
</script>
